import { render, staticRenderFns } from "./DurationInput.vue?vue&type=template&id=2730827e&scoped=true&"
import script from "./DurationInput.vue?vue&type=script&lang=js&"
export * from "./DurationInput.vue?vue&type=script&lang=js&"
import style0 from "./DurationInput.vue?vue&type=style&index=0&id=2730827e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2730827e",
  null
  
)

export default component.exports